module.exports = __webpack_public_path__ + "static/img/iphone_room_right.75e2a02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_room_right.png
// module id = eaiD
// module chunks = 0